var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component-header"},[_c('div',{staticClass:"component-header__leftTitle"},[_c('img',{attrs:{"src":require('@/assets/img/other/header.svg')}}),_c('span',[_vm._v("不动产垂直领域数字化服务平台")])]),_c('div',{staticClass:"component-header__rightTitle"},[_c('span',[_vm._v(_vm._s(_vm.getCurrentDate()))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }